import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import headerBackground from 'assets/images/Header/bg.png'
import squares from 'assets/images/Header/squares.png'
import supportIcon from 'assets/images/support-mobile.png'
import { fade } from 'styles/animations'

export const Hero = styled.header`
  ${() => css`
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 80px);
    background-image: url(${headerBackground});
    background-size: cover;
    background-position: center top;
    flex-direction: column;
    margin-top: 80px;
    max-height: 1080px;

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 40px;
      bottom: 0;
      left: 0;
      z-index: 0;
      background-image: linear-gradient(to top, white, rgba(255, 255, 255, 0));
    }

    @media (max-width: 1400px) {
      padding-bottom: 30px;
    }

    ${fade(2)}

    ${media.lessThan('medium')`
      justify-content: flex-start;
      height: calc(100vh + 58px);
      padding-top: 0;
      margin-top: unset;
    `}
  `}
`

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  position: relative;

  @media (max-width: 1400px) {
    max-width: 1120px;
  }

  ${media.lessThan('medium')`
    margin: 0;
  `}
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 80px 50px 0 50px;

  ${media.lessThan('medium')`
    padding: 0;
  `}
`

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    top: -80px;
    left: -70px;
    width: 324px;
    height: 65px;
    background-image: url(${squares});
    background-repeat: no-repeat;

    @media (max-height: 970px) {
      top: -30px;
    }

    @media (max-height: 770px) {
      top: 20px;
    }

    @media (max-height: 602px) {
      top: 35px;
    }

    ${media.lessThan('medium')`
      height: 100%;
      max-height: 420px;
      margin-top: 0;
      padding: 0;
    `}

    ${media.lessThan('medium')`
      display: none;
    `}
  }

  @media (max-width: 1400px) {
    padding-top: 40px;
  }

  ${media.lessThan('medium')`
    height: 100%;
    max-height: 420px;
    margin-top: 0;
    padding: 0;
  `}

  @media screen and (device-aspect-ratio: 40/71) {
    max-height: 300px;
  }
`

export const Banner = styled.img`
  ${() => css`
    object-fit: contain;
    width: 100%;

    ${fade(2)}

    ${media.lessThan('medium')`
      margin-top: 0;
      height: 100%;
    `}
  `}
`

export const DateWrapper = styled.div`
  ${({ show }) => css`
    display: flex;
    position: relative;
    width: 100%;
    bottom: 10px;
    left: -5px;
    opacity: ${show ? 1 : 0};
    transition: transform 0ms !important;

    ${fade(2)}

    @media (max-width: 1400px) {
      bottom: 30px;
    }

    @media (max-height: 602px) {
      bottom: 35px;
    }

    ${media.lessThan('medium')`
      position: unset;
      left: unset;
      width: 100%;
      justify-content: center;
    `}
  `}
`

export const DateUnit = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:not(:first-child) {
    margin-left: 1vw;
    margin-right: 1vw;
  }

  &:first-child {
    margin-left: 0px;
    margin-right: 1vw;
  }

  &:last-child {
    margin-left: 1vw;
    margin-right: 0px;
  }

  ${media.lessThan('medium')`
    &:not(:first-child) {
      margin-left: 2vw;
      margin-right: 2vw;
    }

    &:first-child {
      margin-left: 0px;
      margin-right: 2vw;
    }

    &:last-child {
      margin-left: 2vw;
      margin-right: 0px;
    }
  `}
`

export const Date = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.grayscale.light.info};
    font-family: ${theme.font.familyTertiary};
    font-size: ${theme.font.sizes.title};
    text-align: center;

    ${fade(2)}

    @media (max-width: 1400px) {
      font-size: ${theme.font.sizes.xxlarge};
    }

    ${media.lessThan('medium')`
      font-size: ${theme.font.sizes.xlarge};
      font-weight: ${theme.font.regular};
      line-height: 48px;
      letter-spacing: 1px;
    `}
  `}
`

export const DateDot = styled(Date)``

export const DateLabels = styled.span`
  ${({ theme }) => css`
    margin: 8px 0 0;
    color: ${theme.colors.grayscale.light.info};
    font-family: ${theme.font.primary};
    font-size: ${theme.font.sizes.small};
    text-align: center;

    ${fade(2)}

    ${media.lessThan('medium')`
      font-size: 10px;
      font-weight: ${theme.font.regular};
      line-height: 12px;
      letter-spacing: 3px;
    `}
  `}
`

export const Button = styled.button`
  ${({ theme }) => css`
    background-color: ${theme.colors.quaternary.main};
    box-shadow: 2px 2px 30px 0px #e3722299;
    height: 48px;
    min-height: 48px;
    width: 160px;
    color: white;
    position: relative;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    font-family: ${theme.font.primary};
    font-weight: ${theme.font.black};
    font-size: ${theme.font.sizes.medium};
    border-radius: 4px;
    cursor: pointer;
    transition: color 350ms ease, border 350ms ease, background-color 350ms ease !important;

    ${fade(2)}

    @media (max-width: 1400px) {
      bottom: 20px;
    }

    @media (max-height: 800px) {
      bottom: 60px;
    }

    @media (max-height: 700px) {
      bottom: 85px;
    }

    ${media.lessThan('medium')`
      margin-top: 50px;
      bottom: 0;
    `}

    &:hover {
      background-color: rgba(255, 255, 255, 0);
      border: 2px solid ${theme.colors.quaternary.main};
      color: ${theme.colors.quaternary.main};
    }
  `}
`

export const SupportBtn = styled.button`
  ${({ theme }) => css`
    width: 150px;
    height: 32px;
    border-radius: 16px;
    margin: ${theme.spacings.medium} auto;
    font-size: 12px;
    font-weight: 400;
    padding: 0 ${theme.spacings.xxsmall};
    color: white;
    background-color: ${theme.colors.primary.main};
    justify-content: space-around;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: ${theme.spacings.xlarge};
    right: ${theme.spacings.xlarge};
    opacity: 1;
    transition: background-color 250ms ease, border 250ms ease, color 250ms ease;
    cursor: pointer;
    z-index: 50;
    border: 1px solid rgba(255, 255, 255, 0.4);

    svg {
      path {
        fill: white;
        transition: fill 250ms ease;
      }
    }

    &:hover {
      background-color: ${theme.colors.neutral.primary};
      border: 1px solid ${theme.colors.primary.main};
      color: ${theme.colors.primary.main};

      svg {
        path {
          fill: ${theme.colors.primary.main};
        }
      }
    }

    ${media.lessThan('medium')`
      height: 46px;
      width: 46px;
      border-radius: 50%;
      font-size: 0;
      bottom: ${theme.spacings.medium};
      right: ${theme.spacings.medium};
      background-image: url(${supportIcon});
      background-repeat: no-repeat;
      background-position: 50%;

      &:hover {
        background-color: ${theme.colors.primary.main};
      }

      svg {
        display: none;
      }
    `}

    @media screen and (device-aspect-ratio: 40/71) {
      bottom: ${theme.spacings.xxsmall};
      right: ${theme.spacings.small};
    }
  `}
`

export const Link = styled.a`
  position: absolute;
  width: 100%;
  height: 100%;
`
